let PackagesItem = [
    {
        track: 'Junior',
        trackJunior: true,
        trackTitle: "Junior Track",
        trackSubtitle: true,
        trackPrice: "0",
        runningString: true,
        trackButton: "Register",
        // trackLink: 'https://geekle.us/ticketfree/1679305454687x631023230746099700',
        juniorTicket1Name: "Free Ticket",
        juniorTicket1Price: "0.00",
        juniorTicket1Link: "https://geekle.us/ticketfree/1679305454687x631023230746099700",
        juniorTicket2Name: "+ Recordings",
        juniorTicket2Price: "9.99",
        juniorTicket2Link: "https://geekle.us/ticket/1699050300403x980067052084002800",
        juniorTicket3Name: "+ Certificate & Recordings",
        juniorTicket3Price: "15.99",
        juniorTicket3Link: "https://geekle.us/ticket/1699051655979x765852066876227600",
    },
    {
        track: 'Full Access',
        trackSale: 'full35',
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "ticket",
        runningString: true,
        trackFullPrice: "169",
        trackPrice: "110",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Track Access',
        trackLink: 'https://geekle.us/ticket/1679320884836x972946664067956700',
    },
    {
        track: 'Year',
        trackSale: 'year40',
        trackTitle: "YEAR OF UI/UX ❤️",
        trackSubtitle: "package",
        runningString: true,
        trackFullPrice: "219",
        trackPrice: "126",
        earlyBird: "one year access",
        trackDesc: "1",
        trackText: true,
        yearTrackText: true,
        trackText1: "One Year Package",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1695906507525x222062140509388800',
    },
    {
        track: 'Premium',
        trackSale: 'premium',
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackFullPrice: "399",
        trackPrice: "199",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        // trackLink: 'https://buy.stripe.com/00g8A760U4V98ak8wI',
        trackLink: 'https://geekle.us/ticket/1694674216925x150092279823204350',
        inverseColors: true,
    },
    // {
    //     trackTitle: "TEAM-5",
    //     trackSubtitle: "YEAR GROUP PACKAGE",
    //     trackPriceApperance: 3,
    //     runningString: true,
    //     trackPrice: "999",
    //     trackText: true,
    //     trackText1: "One Year Pass for 5 team members",
    //     trackDesc: "1",
    //     trackButton: "BUY",
    //     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    // },
    // {
    //     trackMode: 'Halloween',
    //     trackTitle: "FRANKENSTEIN'S HALLOWEEN 3+1 PACK",
    //     trackSubtitle: true,
    //     trackPrice: "179",
    //     trackText: true,
    //     trackButton: "GRAB SPOOKY DEAL",
    //     trackLink: 'https://geekle.us/ticket/1698044453451x220433225697198100',
    // },
    {
        track: 'Unlimited',
        trackSale: 'enterprize',
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
